import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { returnApplicationFailed, suspendedApplicationFailed, suspendedApplicationSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { NO_CONTENT } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* suspendedApplication(action) {
  try {
    const { id, values } = action.payload;
    const url = `${BACKEND_URL}/resources/applications/${id}/suspend`;
    const dataResponse = yield makeRequest(url, values, action, 'POST', true);
    if (dataResponse.status === NO_CONTENT) {
      yield put(suspendedApplicationSuccessful());
      yield call(resolveActionPromise(action));
    } else {
      const data = yield getBodyJson(dataResponse);
      yield put(suspendedApplicationFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(suspendedApplicationFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
